import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const AuditFilters = ({ 
  selectedLocation, 
  onLocationChange, 
  selectedStatus, 
  onStatusChange,
  searchQuery,
  onSearchChange 
}) => {
  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'Plant 1 - Main Facility', label: 'Plant 1 - Main Facility' },
    { value: 'Plant 2 - North Wing', label: 'Plant 2 - North Wing' },
    { value: 'Plant 3 - South Wing', label: 'Plant 3 - South Wing' },
    { value: 'Warehouse 1', label: 'Warehouse 1' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'draft', label: 'Draft' },
    { value: 'active', label: 'Active' },
    { value: 'completed', label: 'Completed' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Search Audits
          </label>
          <Input
            type="text"
            placeholder="Search by title or description..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Location
          </label>
          <Select
            options={locationOptions}
            value={selectedLocation}
            onChange={onLocationChange}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Status
          </label>
          <Select
            options={statusOptions}
            value={selectedStatus}
            onChange={onStatusChange}
          />
        </div>
      </div>
    </div>
  );
};

export default AuditFilters;